import { type CommodityItem } from 'core/domain/CommodityItem'
import { type Mode } from 'core/domain/Mode'
import { type Shipper } from 'core/domain/Shipper'
import { type Stop } from 'core/domain/Stop'
import { type TruckType } from 'core/domain/Truck'

export enum ShipmentNextStep {
  AssignDriver = 'assign-driver',
  AddTruckingInfo = 'add-trucking-info',
  AddTracking = 'add-tracking',
  CheckIn = 'check-in',
  CheckOut = 'check-out',
  UploadDocuments = 'upload-documents',
}

export type Driver = {
  carrier: string
  email?: string
  name?: string
  phoneNumber?: string
  roles?: Array<string>
  uuid: string
}

export type LastLocation = {
  city: string
  enteredBy?: string
  latitude: string
  longitude: string
  source: string
  state: string
  timestamp: Date
  uuid: string
}

export type ShipmentIdentifier = {
  label: string
  values: Array<string>
}

export type BaseShipment = {
  items: Array<CommodityItem>
  driver?: Driver
  equipmentType: TruckType
  identifiers: Array<ShipmentIdentifier>
  lastLocation?: LastLocation
  mode: Mode
  mileage: number
  shipmentURL: string
  shipper: Shipper
  status: string
  stops: Array<Stop>
  tractorNumber?: string
  uuid: string
}

export function getAllIdentifiersCount({ identifiers }: BaseShipment) {
  return identifiers.reduce((count, { values }) => {
    return count + values.length
  }, 0)
}

export function getPOIdentifiers({ identifiers }: BaseShipment): ShipmentIdentifier | undefined {
  return identifiers.find(identifier => identifier.label === 'PO')
}

export function hasDriverAssigned({ driver }: BaseShipment) {
  return Boolean(driver)
}

export function hasLastLocation({ lastLocation }: BaseShipment) {
  return Boolean(lastLocation)
}

export function hasTractorNumberAssigned({ tractorNumber }: BaseShipment) {
  return Boolean(tractorNumber)
}
